import { TEN_MINUTES_IN_MS, THIRTY_MINUTES_IN_MS } from '@/legacy/constants';
import { fetchRequest } from '@/legacy/services';
import { Option } from '@/legacy/types';
import { useQuery } from '@tanstack/react-query';

export const useOptionsQuery = (
	queryKey: string | string[],
	endpoint: string,
	enabled: boolean = true,
) => {
	const { data, isLoading, error } = useQuery<Option[]>({
		queryKey: typeof queryKey === 'string' ? [queryKey, endpoint] : [...queryKey, endpoint],
		queryFn: async () => {
			const response = await fetchRequest<Option[]>({
				url: endpoint,
				method: 'GET',
			});
			return response.data;
		},
		refetchOnWindowFocus: false,
		retry: false,
		staleTime: TEN_MINUTES_IN_MS,
		gcTime: THIRTY_MINUTES_IN_MS,
		enabled: enabled,
	});

	return { data, isLoading, error };
};
